import { DirectiveOptions } from "vue/types/options";

export const targetBlankDirective: DirectiveOptions = {
  bind: (el: HTMLElement): void => {
    el.setAttribute("target", "_blank");
    el.setAttribute("rel", "noopener noreferrer");
  },
};
